const TAIWAN_COUNTRY_ID = '152';

export const getDefaultCountryID = (countries = []) => {
    const taiwan = countries.find(country => String(country.countryID) === TAIWAN_COUNTRY_ID);
    return taiwan?.countryID || countries[0]?.countryID || '';
};
